<template>
  <v-navigation-drawer
    app
    fixed
    v-model="show"
    v-bind="$attrs"
    height="100%"
  >
    <template v-slot:prepend>
      <slot name="header"></slot>
    </template>
    <template v-slot:default>
      <slot></slot>
    </template>
    <template v-slot:append>
      <slot name="footer"></slot>
    </template>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'NavigationDrawer',
  props: {
    toggleId: {
      type: String,
      required: true
    },
    breakPoint: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    show: false
  }),
  mounted: function () {
    this.show = this.$vuetify.breakpoint[this.breakPoint] || false
  },
  created: function () {
    window.eventBus.$on('toggle-drawer', drawer => {
      if (drawer === this.toggleId) {
        this.show = !this.show
      }
    })
  }
}
</script>
